import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import SEO from "./seo.component";
import { useUserParams } from "../hooks/useUserParams";

export default function AboutPage() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentAbout,
    getCurrentHeadshot,
  } = useUserParams();

  const agentName = getCurrentAgentName();
  const agentTitle = getCurrentAgentTitle();
  const agentNumber = getCurrentAgentNumber();
  const agentEmail = getCurrentAgentEmail();
  const brokerage = getCurrentBrokerage();
  const aboutText = getCurrentAbout();
  const headshot = getCurrentHeadshot();

  return (
    <>
      <SEO title="About" description={`About ${agentName || constants.AGENT_NAME}`} />
      <div className="max-w-[1100px] mx-auto gap-x-24 gap-y-12 px-6 grid sm:grid-cols-2 my-12 min-h-[70vh] pt-44">
        <div>
          <img
            src={headshot}
            alt={agentName}
            width={500}
            height={500}
            className="w-full"
          />
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black text-3xl">{agentName}</h2>
            <p className="italic text-lg">
              {agentTitle}, {brokerage}
            </p>

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS)?.map(([key, value]) => (
                <a
                  key={key}
                  href={value}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon
                    className="fa-xl text-logo-second"
                    icon={constants.ICONS[key]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">{agentNumber}</p>
            <p className="text-lg">{agentEmail}</p>
          </div>
        </div>
        <div>
          <h1 className="text-4xl text-black pb-8 font-mont">{constants.ABOUT_TITLE}</h1>
          <p>{aboutText || constants.ABOUT_DESCRIPTION}</p>
        </div>
      </div>
    </>
  );
}
